import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type RouteFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const RouteFilled = forwardRef<SVGSVGElement, RouteFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-11.887981 -12.068516) scale(2.29222)">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.77526 13.1596H10.8453C10.9771 12.8742 11.1883 12.6323 11.4539 12.4626C11.7195 12.2929 12.0284 12.2024 12.344 12.2019C13.0086 12.2019 13.5762 12.5946 13.8392 13.1596H14.7461C15.1268 13.1596 15.4383 13.4697 15.4383 13.8486C15.4383 14.2276 15.1268 14.5376 14.7461 14.5376H13.8392C13.5762 15.0991 13.0051 15.4953 12.344 15.4953C11.6795 15.4953 11.1084 15.1026 10.8488 14.5376H7.77872C6.4254 14.5376 5.40436 13.5213 5.40436 12.1744C5.40436 10.8274 6.41848 9.8111 7.77526 9.8111H13.0639C13.6558 9.8111 14.0538 9.41493 14.0538 8.82584C14.0538 8.23675 13.6558 7.84058 13.0639 7.84058H9.99387C9.73083 8.40555 9.15973 8.79828 8.49865 8.79828C7.83756 8.79828 7.26647 8.40555 7.00342 7.84058H6.09659C5.71586 7.84058 5.40436 7.53053 5.40436 7.15158C5.40436 6.77263 5.71586 6.46259 6.09659 6.46259H7.00342C7.26647 5.90105 7.83756 5.50488 8.49865 5.50488C9.15973 5.50488 9.73083 5.89761 9.99387 6.46259H13.0639C14.4173 6.46259 15.4383 7.47885 15.4383 8.82584C15.4383 10.1728 14.4138 11.1891 13.0605 11.1891H7.77526C7.1834 11.1891 6.78537 11.5853 6.78537 12.1744C6.78537 12.7634 7.17994 13.1596 7.77526 13.1596Z" />
      </g>
    </svg>
  ),
);

RouteFilled.displayName = 'RouteFilled';

export default RouteFilled;
